import { render, staticRenderFns } from "./MoveEmail.vue?vue&type=template&id=89ff3094&scoped=true&"
import script from "./MoveEmail.vue?vue&type=script&lang=js&"
export * from "./MoveEmail.vue?vue&type=script&lang=js&"
import style0 from "./MoveEmail.vue?vue&type=style&index=0&id=89ff3094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ff3094",
  null
  
)

export default component.exports